import { styled } from '@mui/material/styles';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiRadio from '@mui/material/Radio';

export const FormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.neutrals.beige3}`,
  paddingTop: theme.spacing(0.1),
  paddingBottom: theme.spacing(0.1),
  ':last-child': {
    borderBottom: 'none'
  }
}));

export const Radio = styled(MuiRadio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.brand.darkGreen
  }
}));
